import React, { useState, useEffect } from "react";
import {
  EyeIcon,
  CogIcon,
  XCircleIcon,
  SearchIcon,
  ShareIcon,
  UserCircleIcon,
} from "@heroicons/react/solid";
import { connect, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomFilter from "./filterModal";

// components
import GameListModal from "./gameListModal";
import ActionModal from "./actionModal";
import SendEmailModal from "./sendEmailModal";
import CustomViewModal from "./CustomViewModal";
import CustomListViewModal from "./CustomListViewModal";
import FullProfileModal from "./fullProfileModal";
import CustomListModal from "./customListModal";

import {
  listDownloadResume,
  listSendSingleInvite,
  listSingleUserResume,
  listResetGame,
  listUnlockGame,
  listGetAllTags,
  listGetCustomHeaders,
} from "../../../redux/actions/nrp/listActions";
import { toAbsoluteUrl } from "../../../services";
import { Modal, UserProfile } from "../../components";
import ListModal from "./listModal";
import { competenciesAssessments } from "../dashboard/data";

// get step data from redux main state
const data = (state) => state.nrpList;

const CustomToolbar = (props) => {
  let { totalAssessments, tagsList } = useSelector(data);
  const [gameListModal, setGameListModal] = useState(false);
  const [customListModal, setCustomListModal] = useState(false);
  const [actionModal, setActionModal] = useState(false);
  const [resumeModal, setResumeModal] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const [compareModal, setCompareModal] = useState(false);
  const [campareView, setCompareView] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [customViewModal, setCustomViewModal] = useState(false);
  const [userProfileModal, setUserProfileModal] = useState(false);
  const [fullProfileModal, setFullProfileModal] = useState(false);
  const [listModal, setListModal] = useState(false);
  const [email, setEmail] = useState("");
  const [singleUserId, setSingleUserId] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [topCandidate, setTopCandidates] = useState("");
  const [assessmentMenu, setAssessementMenu] = useState([]);
  const [status, setStatus] = useState("1");
  const [filters, setFilters] = useState([]);
  const [isCustomListView, setIsCustomViewList] = useState(true);

  let {
    campaign,
    singleUserProfile,
    allSelectedUsersIds,
    overAllSelectedUsers,
    getStatus,
  } = props;
  // Functions
  // Action Menu Handel Started
  let handelActionMenu = (type, data) => {
    // Single User Profile Handler Started
    if (type === "profileResume") {
      if (data.userResume) {
        props.listSingleUserResume(data.userResume);
      } else {
        toast("No Resume Found!", {
          position: "bottom-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }

    if (type === "profileMessage") {
      setEmailModal(!emailModal);
      setEmail(data.userEmail);
    }

    if (type === "profileFull") {
      setSingleUserId(data.userId);
      setFullProfileModal(!fullProfileModal);
    }
    // Single User Profile Handler END

    // Main Action Start

    if (type === "list") {
      setListModal(!listModal);
      setActionModal(!actionModal);
    }
    if (type === "downloadResume") {
      setActionModal(!actionModal);
      setResumeModal(!resumeModal);
      // props.downloadResume(selectedUsersIds);
    }
    if (type === "sendEmail") {
      setActionModal(!actionModal);
      if (overAllSelectedUsers.length === 1) {
        setEmailModal(!emailModal);
        setEmail(overAllSelectedUsers[0].email);
      } else {
        toast("Single Invite Allowed!", {
          position: "bottom-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }

    if (type === "compare") {
      setCompareModal(!compareModal);
    }

    if (type === "resetGame") {
      if (allSelectedUsersIds.length > 10) {
        toast("Max 10 users allowed!", {
          position: "bottom-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (allSelectedUsersIds.length === 0) {
        toast("Please Select Candidate!", {
          position: "bottom-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        props.listResetGame(campaign, allSelectedUsersIds);
        setTimeout(() => {
          props.defaultApiCall();
          setActionModal(!actionModal);
        }, 500);
      }
    }
    if (type === "unlockGame") {
      if (allSelectedUsersIds.length > 10) {
        toast("Max 10 users allowed!", {
          position: "bottom-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (allSelectedUsersIds.length === 0) {
        toast("Please Select Candidate!", {
          position: "bottom-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        props.listUnlockGame(campaign, allSelectedUsersIds);
        setTimeout(() => {
          props.defaultApiCall();
          setActionModal(!actionModal);
        }, 500);
      }
    }
  };
  // Action Menu Handel Ended

  let sendEmailInvite = (emailObj) => {
    props.listSendSingleInvite(campaign, emailObj);
    setEmailModal(!emailModal);
  };

  // Download Resume Function Started
  let handelResumeDownload = () => {
    if (allSelectedUsersIds.length > 0) {
      props.listDownloadResume(allSelectedUsersIds);
      setResumeModal(!resumeModal);
    } else {
      toast("Please Select Candidates!", {
        position: "bottom-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setResumeModal(!resumeModal);
    }
  };
  // Download Resume Function Ended

  // Game List Function Started
  let handelStatusData = (status, filters) => {
    setStatus(status);
    setFilters(filters);
    setSearchValue("");
    props.handelSearchCandidate("");
    setIsCustomViewList(false);
    getStatus(status, filters, false);
  };
  // Game List Function Ended

  // Custom List Function Started
  let handelCustomStatusData = (status, filters, isCustomList) => {
    props.handelSearchCandidate("");
    setSearchValue("");
    setIsCustomViewList(true);
    getStatus(status, filters, isCustomList);
  };
  // Custom List Function Ended

  // Search and date filter functions to send data in parent  start
  let _handleSearch = (e) => {
    let search = searchValue;
    props.handelSearchCandidate(search);
  };

  useEffect(() => {
    if (singleUserProfile.name) {
      setUserProfileModal(!userProfileModal);
    }
  }, [singleUserProfile]);

  // useEffect(() => {
  //   if (assessmentMenu.length === 0) {
  //     let totalAssessmentsArray = [];
  //     totalAssessments &&
  //       totalAssessments.forEach((competency) => {
  //         totalAssessmentsArray.push({
  //           headerName: competenciesAssessments[
  //             competency.title.replace("''", "'")
  //           ]
  //             ? competenciesAssessments[competency.title.replace("''", "'")]
  //                 .title
  //             : competency.title,
  //           field: competency.title,
  //           sort: "desc",
  //           width: 120,
  //           headerAlign: "center",
  //           align: "center",
  //         });
  //       });
  //     setAssessementMenu(totalAssessmentsArray);
  //   }
  // }, [totalAssessments]);

  useEffect(() => {
    let topCandidate =
      tagsList &&
      tagsList.filter((label) => {
        return label.name == "Top Candidates";
      });
    setTopCandidates(topCandidate ? topCandidate[0] : {});
  }, [tagsList]);
  return (
    <div>
      <div className="flex flow-row items-center justify-between flex-wrap px-2">
        <div className="flex flex-row  w-9/12">
          <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => {
                if (topCandidate && topCandidate.name) {
                  handelCustomStatusData(
                    null,
                    [
                      {
                        columnName: "tagId",
                        columnType: "tagId",
                        value: topCandidate && topCandidate.id,
                      },
                    ],
                    true
                  );
                }
              }}
              id="dropdownDividerButton"
              data-dropdown-toggle="dropdownDivider"
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <UserCircleIcon className="w-5 h-5 mr-2" color="white" />
              {topCandidate && topCandidate.name}
            </button>
          </div>

          <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => setCustomListModal(!customListModal)}
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <ShareIcon className="w-5 h-5 mr-2" color="white" />
              Custom List
            </button>
          </div>

          <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => setGameListModal(!gameListModal)}
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <ShareIcon className="w-5 h-5 mr-2" color="white" />
              Game Lists
            </button>
          </div>

          <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => setCustomViewModal(!customViewModal)}
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <EyeIcon className="w-5 h-5 mr-2 " color="white" />
              Custom View
            </button>
          </div>

          <div className="w-[20%] py-4 mr-2">
            <button
              onClick={() => {
                setActionModal(!actionModal);
              }}
              id="dropdownDividerButton"
              data-dropdown-toggle="dropdownDivider"
              type="button"
              className="text-[white] w-full justify-center bg-[#007E8C] font-medium rounded-lg text-sm px-2 py-2.5 text-center flex flex-row items-center"
            >
              <CogIcon className="w-5 h-5 mr-2" color="white" />
              Action
            </button>
          </div>
        </div>

        <div className="w-3/12">
          <div className="flex justify-center items-center relative">
            <SearchIcon className="absolute text-[#8B83BA] left-2   w-6 h-6" />
            <input
              onChange={(e) => {
                setSearchValue(e.target.value);
                if (!e.target.value) {
                  props.handelSearchCandidate("");
                }
              }}
              value={searchValue}
              placeholder="Candidate Search"
              className="text-sm text-[#8B83BA] font-medium border border-[#E6E6E6] bg-[#F4F2FF] focus:outline-none pl-10 pr-10 focus:bg-white focus:border-gray-500 rounded-lg py-2.5 w-full"
            />
            {searchValue.length > 0 ? (
              <button
                onClick={_handleSearch}
                className="absolute right-2 text-[#FFFFFF] bg-[#A79FD7] text-xs border broder-[#A79FD7] px-2 rounded-lg py-2 "
              >
                Search
              </button>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>

      {/* User Profile Started */}
      <Modal
        classCustom="2xl:w-3/12 xl:w-4/12 lg:w-4/12 w-10/12"
        open={userProfileModal}
        onBackdropClick={() => {
          setUserProfileModal(!userProfileModal);
          props.close();
        }}
      >
        <UserProfile
          campaign={campaign}
          handelActionMenu={handelActionMenu}
          closeHandler={() => {
            setUserProfileModal(!userProfileModal);
            props.close();
          }}
          user={singleUserProfile}
        />
      </Modal>
      {/* User Profile Ended */}

      {/* Custom View Started */}

      <Modal
        overflow={true}
        height={true}
        classCustom="w-8/12"
        open={customViewModal}
        onBackdropClick={() => setCustomViewModal(!customViewModal)}
      >
        {isCustomListView ? (
          <CustomListViewModal
            check={false}
            assessmentMenu={totalAssessments}
            handelNo={() => setCustomViewModal(!customViewModal)}
          />
        ) : (
          <CustomViewModal
            assessmentMenu={totalAssessments}
            handelNo={() => setCustomViewModal(!customViewModal)}
          />
        )}
      </Modal>
      {/* Custom View Ended */}

      {/* Export Action Modal Started */}
      <ActionModal
        handelActionMenu={handelActionMenu}
        actionModal={actionModal}
        onBackdropClick={() => setActionModal(!ActionModal)}
        handelNo={() => setActionModal(!ActionModal)}
      />
      {/* Export Action Modal Ended */}

      {/* Custom Lists Started */}

      <ListModal
        listModal={listModal}
        handelNo={() => setListModal(!listModal)}
        campaign={campaign}
        usersIds={allSelectedUsersIds}
      />
      {/* Custom Lists Ended */}

      {/* Type === "downloadResume" */}
      <Modal
        open={resumeModal}
        onBackdropClick={() => setResumeModal(!resumeModal)}
      >
        <div className="bg-white border-1 border-[#FEBB13]">
          <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
            <h3></h3>
            <h3 className="text-[#FFFFFF] ml-4 font-semibold ">
              Confirm Export
            </h3>
            <XCircleIcon
              onClick={() => setResumeModal(!resumeModal)}
              className="w-7 h-7 cursor-pointer "
              color="white"
            />
          </div>
          <div className="px-10 my-4 ">
            <p className="text-center text-lg text-[#333333] font-medium">
              Are you sure you want to download the resume of the selected
              candidates?
            </p>
            <div className="flex justify-center items-center my-6">
              <img
                src={toAbsoluteUrl("/media/nrp/leaderboard/resume.png")}
                alt="Action Icon"
                className="w-20 h-20"
              />
            </div>
          </div>
          <div className="absolute bottom-4 w-full flex flex-row justify-center">
            <button
              onClick={handelResumeDownload}
              className="bg-[#FEBB12] text-[white] px-10 py-2 mx-2"
            >
              Yes
            </button>
            <button
              onClick={() => setResumeModal(!resumeModal)}
              className="bg-[#007E8C] text-[white] px-10 py-2 mx-2"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
      {/* Type === "emailSend" */}
      <Modal
        classCustom="2xl:w-[40%] xl:w-[40%] lg:w-[40%] md:w-[70%] w-[80%] mt-[2%] border-2 border-[#FEBB12] h-max pb-6"
        open={emailModal}
        onBackdropClick={() => setEmailModal(!emailModal)}
      >
        <SendEmailModal
          campaignData={campaign}
          sendEmailInvite={sendEmailInvite}
          value={email}
          close={() => setEmailModal(!emailModal)}
        />
      </Modal>

      {/* Type === "compare users" */}
      <Modal
        open={compareModal}
        onBackdropClick={() => setCompareModal(!compareModal)}
      >
        <div className="bg-white border-1 border-[#FEBB13]">
          <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
            <h3></h3>
            <h3 className="text-[#FFFFFF] ml-4 font-semibold ">
              Compare Candidates
            </h3>
            <XCircleIcon
              onClick={() => setCompareModal(!compareModal)}
              className="w-7 h-7 cursor-pointer "
              color="white"
            />
          </div>
          <div className="px-10 my-4 ">
            <p className="text-center text-lg text-[#333333] font-medium">
              {overAllSelectedUsers.length > 8
                ? "Only 8 Candidates are allowed"
                : overAllSelectedUsers.length < 1
                ? "No candidate is selected"
                : "You can select upto 8 candidates to compare at the same time."}
            </p>
            <div className="flex justify-center items-center my-6">
              <img
                src={toAbsoluteUrl("/media/nrp/leaderboard/compare.png")}
                alt="Action Icon"
                className="w-20 h-20"
              />
            </div>
          </div>
          <div className="absolute bottom-4 w-full flex flex-row justify-center">
            <button
              onClick={() => {
                overAllSelectedUsers.length < 1
                  ? setCompareModal(!compareModal)
                  : overAllSelectedUsers.length > 8
                  ? setCompareModal(!compareModal)
                  : setCompareView(!campareView);
              }}
              className="bg-[#FEBB12] text-[white] px-10 py-2 mx-2"
            >
              Yes
            </button>
            <button
              onClick={() => setCompareModal(!compareModal)}
              className="bg-[#007E8C] text-[white] px-10 py-2 mx-2"
            >
              No
            </button>
          </div>
        </div>
      </Modal>
      {/* Game List Modal Started */}
      <GameListModal
        handelStatusData={handelStatusData}
        gameListModal={gameListModal}
        onBackdropClick={() => setGameListModal(!gameListModal)}
        handelNo={() => setGameListModal(!gameListModal)}
      />
      {/* Game List Modal Ended */}

      {/* Custom List Modal Started */}
      <CustomListModal
        handelCustomStatusData={handelCustomStatusData}
        customListModal={customListModal}
        onBackdropClick={() => setCustomListModal(!customListModal)}
        handelNo={() => setCustomListModal(!customListModal)}
        campaign={campaign}
      />
      {/* Custom List Modal Ended */}

      {/* Is Compare View  */}
      <Modal
        overflow={true}
        height={true}
        classCustom="w-[100%] h-[100%]"
        open={campareView}
        onBackdropClick={() => {
          setCompareView(!campareView);
          setCompareModal(!compareModal);
        }}
      >
        <div>
          <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
            <h3></h3>
            <h3 className="text-[#FFFFFF] ml-4 text-lg font-semibold ">
              Compare Candidates
            </h3>
            <XCircleIcon
              onClick={() => {
                setCompareView(!campareView);
                setCompareModal(!compareModal);
              }}
              className="w-8 h-8 cursor-pointer "
              color="white"
            />
          </div>

          <div className="flex flex-row flex-wrap items-center px-10 py-10">
            {overAllSelectedUsers &&
              overAllSelectedUsers.map((candidate, i) => {
                return (
                  <div className="w-3/12 ">
                    <UserProfile
                      custom="rounded-md shadow-lg my-4  mx-2"
                      showClose={false}
                      key={i}
                      handelActionMenu={handelActionMenu}
                      closeHandler={() => {
                        setUserProfileModal(!userProfileModal);
                        props.close();
                      }}
                      user={candidate}
                      campaign={campaign}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </Modal>
      {/* Full Profile Modal */}

      <Modal
        height={true}
        classCustom="w-9/12"
        open={fullProfileModal}
        onBackdropClick={() => setFullProfileModal(!fullProfileModal)}
      >
        <FullProfileModal
          campaign={campaign}
          user={singleUserId}
          handelNo={() => setFullProfileModal(!fullProfileModal)}
        />
      </Modal>

      {/* Custom Filter Started */}

      <Modal
        overflow={true}
        height={true}
        classCustom="2xl:w-6/12 xl:w-6/12 lg:w-6/12 w-10/12"
        open={filterModal}
        onBackdropClick={() => {
          setFilterModal(!filterModal);
        }}
      >
        <CustomFilter
          campaign={campaign}
          assessmentMenu={assessmentMenu}
          getFilterQueries={(filters) => props.getAllFilterQueries(filters)}
          handelNo={() => setFilterModal(!filterModal)}
        />
      </Modal>

      {/* Custom Filter Ended */}
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  listDownloadResume,
  listSendSingleInvite,
  listSingleUserResume,
  listResetGame,
  listUnlockGame,
  listGetAllTags,
  listGetCustomHeaders,
})(CustomToolbar);
